import { defineComponent, createElementBlock, openBlock, normalizeClass, createVNode, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es93.js';
/* empty css                       */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Table",
  props: {
    hasLightVerticalHeader: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["custom-table", { "has-light-vertical-table-header": props.hasLightVerticalHeader }, "rte-text"])
      }, [
        createVNode(_sfc_main$1, null, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ], 2);
    };
  }
});

export { _sfc_main as default };
